import Integration from './integration';

export default Integration;
